export type Testimonial = {
  id: string
  name: string
  location: string
  rating: number
  quote: string
}

/**
 * PLACEHOLDER CONTENT — sample copy for layout purposes only.
 * Replace with real, verified customer reviews before publishing.
 */
export const testimonials: Testimonial[] = [
  {
    id: 't1',
    name: 'Sample Customer',
    location: 'Louisville, KY',
    rating: 5,
    quote:
      'Placeholder testimonial: describe how the crew prepped the space, kept the job site clean, and finished on schedule.',
  },
  {
    id: 't2',
    name: 'Sample Customer',
    location: 'Lexington, KY',
    rating: 5,
    quote:
      'Placeholder testimonial: highlight the quality of the paint finish and the attention paid to trim and detail work.',
  },
  {
    id: 't3',
    name: 'Sample Customer',
    location: 'Bowling Green, KY',
    rating: 5,
    quote:
      'Placeholder testimonial: mention clear communication from the first estimate through the final walkthrough.',
  },
  {
    id: 't4',
    name: 'Sample Customer',
    location: 'Crestwood, KY',
    rating: 5,
    quote:
      'Placeholder testimonial: share how the finished kitchen or bath changed the way the family uses the home.',
  },
]
